import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';
import {UploadService} from './upload.service';

@Injectable({
    providedIn: 'root'
})
export class AuthorService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService,
                private fileUploadService: UploadService) {
        super(http, alertService, globalService);
    }

    get(data): Observable<any> {
        return this.getRequest(AppUrl.AUTHOR(), data);
    }

    /* count(): Observable<any> {
         return this.getRequest(AppUrl.AUTHOR_COUNT());
     }*/

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.AUTHOR(id));
    }

    create(data): Observable<any> {
        return this.postRequest(AppUrl.AUTHOR(), data);
    }

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.AUTHOR(id), data);
    }

    update_content(id, data): Observable<any> {
        return this.putRequest(AppUrl.AUTHOR_CONTENT(id), data);
    }

    updatePassword(id, data): Observable<any> {
        return this.putRequest(AppUrl.ADMIN_PASSWORD(id), data);
    }

    updateStatus(id, data): Observable<any> {
        return this.putRequest(AppUrl.ADMIN_STATUS(id), data);
    }

    fileUpload(params, event): Observable<any> {
        return this.fileUploadService.fileUpload(AppUrl.FILE_UPLOAD(), params, event);
    }

    fileUploadAdmin(params, event): Observable<any> {
        return this.fileUploadService.fileUpload(AppUrl.FILE_UPLOAD_ADMIN(), params, event);
    }
}
